import { Text } from "@chakra-ui/react";

export type BadgeColorSchema = "default" | "success" | "failed" | "pending";

type BadgeProps = {
  children: React.ReactNode;
  colorScheme?: BadgeColorSchema;
};

export function Badge({ children, colorScheme = "default" }: BadgeProps) {
  const colorMap = {
    pending: {
      color: "#F2B821",
      background: "#FEF8E9",
    },
    success: {
      color: "#45C14A",
      background: "#ECF9ED",
    },
    failed: {
      color: "#FF0000",
      background: "#FFE5E5",
    },
    default: {
      color: "#000000",
      background: "#F5F5F5",
    },
  };

  return (
    <Text
      color={colorMap[colorScheme].color}
      background={colorMap[colorScheme].background}
      fontWeight="semibold"
      fontSize="xs"
      borderRadius="100px"
      border="none"
      px={2}
      py={0}
      as="span"
    >
      {children}
    </Text>
  );
}
